import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { DownloadUploadService } from '@thehubz/client/asset-services';
import { accessAsset, AssetsGenerateUrlService, AssetUIModel, ClientCoreModule } from '@thehubz/client/core';
import { Asset, AssetsApiService, AssetVersion, AssetVersionRef, UpdateAssetDto } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { lastValueFrom, Subscription } from 'rxjs';
import { AssetFullScreen } from '../../../../full-screen/asset-full-screen';
import { AssetCommonService } from '../../../../services/asset-common.service';

@Component({
  selector: 'thehubz-asset-version-card',
  templateUrl: './asset-version-card.component.html',
  styleUrls: ['./asset-version-card.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, ClientCoreModule],
})
export class AssetVersionCardComponent implements OnInit, OnDestroy {
  @Input() assetInfo!: AssetUIModel;
  @Input() version!: AssetVersionRef;
  @Input() defaultVersion?: string;
  @Input() selectedVersion!: string;

  private viewPDFInBrowserSubscription?: Subscription;

  AccessAsset = accessAsset;
  assetVersion?: AssetVersion;
  versionPreviewURL = '';
  bannerImgHidden = false;
  showNewExpandButton = false;
  showNewTabButton = false;
  disableNewTabButton = false;
  @Output() deleteAssetVersionEvent = new EventEmitter<{ assetId: string; versionId: string }>();

  constructor(
    private assetsService: AssetsApiService,
    private assetUrlService: AssetsGenerateUrlService,
    private downloadUploadService: DownloadUploadService,
    protected assetCommonService: AssetCommonService,
    protected assetFullScreen: AssetFullScreen,
  ) {}

  ngOnInit(): void {
    this.assetsService.assetsControllerGetAssetVersion(this.version._id.toString()).subscribe((assetVersion) => {
      this.assetVersion = assetVersion;
      this.createVersionPreviewURL();
    });

    this.showNewExpandButton = !!this.assetInfo.previewUrl;
    this.showNewTabButton = !!this.assetInfo.previewUrl && this.assetInfo.assetType !== Asset.AssetTypeEnum.HtmlBanner;
  }

  async createVersionPreviewURL() {
    this.assetInfo = this.assetUrlService.addPreviewUrl(this.assetInfo, this.version.version);
  }

  buttonDivClick(event: Event) {
    event.stopPropagation();
  }

  async setAsDefault() {
    const formValues: UpdateAssetDto = {
      currentVersion: this.assetVersion?._id,
    };

    const res = await lastValueFrom(this.assetsService.assetsControllerChangeAssetVersion(this.assetInfo._id, formValues));
    res.currentVersion = this.assetVersion;
    const assetInfo = this.assetUrlService.addPreviewUrl(res);
    this.assetCommonService.assetDataSubject$.next(assetInfo);
  }

  openInTab(assetInfo: AnyType, version: number) {
    this.disableNewTabButton = true;
    const previewUrl = this.assetUrlService.getBrowserObjectUrl(assetInfo, version);
    this.viewPDFInBrowserSubscription = this.downloadUploadService.viewInBrowser(previewUrl, assetInfo.mainFile.mimetype).subscribe((res) => {
      this.disableNewTabButton = false;
      const fileURL = URL.createObjectURL(res);
      window.open(fileURL, '_blank');
    });
  }

  ngOnDestroy(): void {
    this.viewPDFInBrowserSubscription?.unsubscribe();
  }
}
